import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ConstructionIcon from "@mui/icons-material/Construction";
import HomeIcon from "@mui/icons-material/Home";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ListAltIcon from "@mui/icons-material/ListAlt";
import FeedIcon from "@mui/icons-material/Feed";
import GppGoodIcon from "@mui/icons-material/GppGood";
import WorkIcon from "@mui/icons-material/Work";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import { useNavigate } from "react-router-dom";
import HelpIcon from "@mui/icons-material/Help";
import Collapse from "@mui/material/Collapse";
// import CircleIcon from "@mui/icons-material/Circle";
import { withStyles, makeStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import listingIcon from "../../assets/images/listingIcon.png";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import { useSelector } from "react-redux";
import OutsideClickHandler from "react-outside-click-handler";
import PhonelinkSetupIcon from "@mui/icons-material/PhonelinkSetup";
import Skeleton from "@mui/material/Skeleton";
import AttachMoneyRoundedIcon from "@mui/icons-material/AttachMoneyRounded";
import CodeIcon from "@mui/icons-material/Code";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
const useStyles = makeStyles((theme) => ({
  navCollapseItems: {
    position: "absolute",
    top: 0,
    left: "65px",
    background: "white",
    width: "180px",
    "& .MuiListItemButton-root": {
      paddingLeft: "16px !important",
      "&.Mui-selected": {
        backgroundColor: "transparent !important",
      },
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04) !important",
      },
    },
  },
  collapsedIcon: {
    "& .MuiListItemIcon-root": {
      minWidth: "32px",
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      border: "none",
      backgroundColor: "rgba(0, 0, 0, 0.08)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "3px",
      marginLeft: "-3px",
      padding: "0px",
      "& .MuiSvgIcon-root": {
        fontSize: "18px",
      },
      "& img": {
        width: "14px !important",
        marginLeft: "-1.5px !important",
        marginTop: "1px !important",
        height: "auto",
        display: "flex",
        alignSelf: "center",
        justifySelf: "center",
      },
    },
  },
}));

function SideNavBar(props) {
  const { classes } = props;
  const muiClasses = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const [shortMenu, setShortMenu] = useState({});

  const [open, setOpen] = useState(["MAIN" /* ,"TOOLS","LEADS" */]);

  const adminAuth = useSelector((state) => state.adminAuth);

  useEffect(() => {
    let path = location.pathname.split("/")[1].toUpperCase();
    setOpen([path]);
  }, []);
  const navBarMenu = [
    {
      title: "MAIN",
      icon: <HomeIcon />,
      route: "/main/dashboard",
      subRoutes: [
        {
          title: "Dashboard",
          route: "/main/dashboard",
        },
        {
          title: "Points",
          route: "/dashboard/points",
        },
      ],
    },
    {
      title: "Search",
      icon: <ImageSearchIcon />,
      route: "/search",
    },
    {
      title: "DOCS",
      icon: <FeedIcon />,
      subRoutes: [
        {
          title: "Forms Library",
          route: "/docs/library",
        },
        {
          title: "Folders",
          route: "/docs/folders",
        },
      ],
    },
    {
      title: "TOOLS",
      icon: <ConstructionIcon />,
      subRoutes: [
        {
          title: "Reporting",
          route: "/tools/reporting/agent-activity",
        },
        {
          title: "Marketing Center",
          route: "/marketing_center/digital",
        },
        {
          title: "CMA",
          route: "/tools/cmas/list",
        },

        {
          title: "Video Marketing",
          route: "/video_marketing",
        },
        {
          title: "recruiting",
          route: "/tools/recruiting",
        },
      ],
    },
    {
      title: "LEADS",
      icon: <PeopleAltIcon />,
      subRoutes: [
        {
          title: "People",
          route: "/leads/people",
        },
        {
          title: "Inbox",
          route: "/leads/inbox",
        },
        {
          title: "Templates",
          route: "/templates/email-templates",
        },
        {
          title: "Reporting",
          route: "/reporting",
        },
        {
          title: "Smart List",
          icon: <ListAltIcon />,
          route: "/leads/smartlists",
        },
      ],
    },
    {
      title: "Listings",
      icon: (
        <img
          style={{
            width: props.pcOpen ? "16px" : "18px",
            marginLeft: props.pcOpen ? "1.5px" : "3px",
          }}
          src={listingIcon}
          alt={"listingIcon"}
        />
      ),
      subRoutes: [
        {
          title: "Listings",
          route: "/listings/active",
        },
        {
          title: "Makeover",
          route: "/listings/makeover/outstanding",
        },
        {
          title: "Open House",
          route: "/listings/open-house/current",
        },
      ],
    },
    {
      title: "TRANSACTIONS",
      icon: <WorkIcon />,
      subRoutes: [
        {
          title: "Transactions",
          route: "/transaction/contracts/active-contracts",
        },
        {
          title: "Task Templates",
          route: "/transaction/task_templates",
        },
      ],
    },
    {
      title: "ADMIN",
      icon: <GppGoodIcon />,
      subRoutes: [
        {
          title: "Agent Roster",
          route: "/agent_roster",
        },
        {
          title: "Reporting",
          route: "/profit-report",
        },
        {
          title: "Events and Alerts",
          route: "/events_and_alerts/events",
        },
        {
          title: "Agent Requests",
          route: "/agent_tickets/open",
        },
        {
          title: "Users",
          route: "/users",
        },
        {
          title: "Vendors",
          route: "/vendors",
        },
        {
          title: "Inventory",
          route: "/inventory/lockbox",
        },
        {
          title: "Lead Routing",
          route: "/lead_routing",
        },
        {
          title: "Send Email As",
          route: "/send_email_as",
        },
        {
          title: "Ponds",
          route: "/ponds",
        },
        {
          title: "Staff Management",
          route: "/staff_management",
        },
      ],
    },
    {
      title: "Phone Configuration",
      icon: <PhonelinkSetupIcon />,
      route: "/phone-configuration/phone-numbers",
    },
    {
      title: "Finance",
      icon: <PaymentsRoundedIcon />,
      route: "/finance/closings/unprocessed",
    },
    {
      title: "Payments",
      icon: <AttachMoneyRoundedIcon />,
      route: `/payments`,
    },
    {
      title: "Projects",
      icon: <TaskAltRoundedIcon />,
      route: "/projects",
    },
    {
      title: "Initiatives",
      icon: <RocketLaunchIcon />,
      route: "/initiatives",
    },
    {
      title: "Development",
      icon: <CodeIcon />,
      route: "/development",
      adminOnly: true,
      subRoutes: [
        {
          title: "AI Agent Diagnostics",
          route: "/development/ai-diagnostics",
        },
      ],
    },
    {
      title: "KNOWLEDGE BASE",
      icon: <HelpIcon />,
      route:
        adminAuth?.adminDetail?.role?.name === "Agents"
          ? "/knowledge-base/main"
          : null,
      subRoutes:
        adminAuth?.adminDetail?.role?.name === "Agents"
          ? null
          : [
              {
                title: "Main",
                route: "/knowledge-base/main",
              },
              {
                title: "Manage Library",
                route: "/knowledge-base/manage-library/posts",
              },
            ],
    },
  ];

  const handleChangeRoute = (route, title) => {
    setOpen([title]);
    setShortMenu((prev) => ({ ...prev, [title]: false }));
    navigate(route);
  };

  const handleClick = (title) => {
    setOpen((prevOpen) => {
      // If title is already in array, remove it (collapse)
      // If not in array, add it (expand)
      return prevOpen.includes(title)
        ? prevOpen.filter((item) => item !== title)
        : [...prevOpen, title];
    });
    setShortMenu((prev) => ({ ...prev, [title]: true }));
  };

  return (
    <React.Fragment>
      {adminAuth.isLoading ? (
        <List>
          {Array.from(Array(18).keys()).map(() => (
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon sx={{ minWidth: "40px" }}>
                  <Skeleton
                    width="22px"
                    height="32px"
                    sx={{ mt: "-6px", mb: "-6px" }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Skeleton
                      height="27px"
                      width="90%"
                      sx={{ mt: "-6px", mb: "-6px" }}
                    />
                  }
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      ) : (
        <div className={classes.sideBarRoot}>
          {props.pcOpen ? (
            <List
              sx={{
                width: "100%",
                maxWidth: 360,
                bgcolor: "background.paper",
                position: "relative",
                overflow: "auto",
                maxHeight: "91vh",
                "& ul": { padding: 0 },
                paddingTop: "0px",
              }}
              classes={{ root: classes.sideBarRootList }}
            >
              {navBarMenu
                .filter((item) => {
                  // Debug logging
                  console.log('Filtering item (expanded):', item.title, {
                    hasRoute: !!item.route,
                    hasSubRoutes: !!item.subRoutes,
                    isAdminOnly: item.adminOnly,
                    userRole: adminAuth.adminDetail?.role?.name,
                    isAdmin: adminAuth.adminDetail?.role?.name === "Admin"
                  });
                  
                  // Check if item is admin-only and user is not admin
                  if (item.adminOnly && adminAuth.adminDetail?.role?.name !== "Admin") {
                    console.log('Filtered out (expanded):', item.title, '- admin only, user not admin');
                    return false;
                  }
                  
                  if (item.route) {
                    // For direct routes
                    // Special case for admin-only items
                    if (item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") {
                      console.log('Allowed (expanded):', item.title, '- admin only, user is admin');
                      return true;
                    }
                    const hasPermission = adminAuth.adminDetail?.role?.role_permissions?.find(
                      (it) =>
                        item.route.split("/").includes(it.permission.slug) &&
                        !it.mobile_only
                    );
                    console.log('Route permission check (expanded):', item.title, hasPermission ? 'allowed' : 'denied');
                    return hasPermission;
                  } else if (item.subRoutes) {
                    // For items with subroutes
                    // If it's admin-only and user is admin, allow it
                    if (item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") {
                      console.log('Allowed (expanded):', item.title, '- admin only with subroutes, user is admin');
                      return true;
                    }
                    // Otherwise check sub-route permissions
                    const hasSubPermission = item.subRoutes.some((sub) =>
                      adminAuth.adminDetail?.role?.role_permissions?.find(
                        (it) =>
                          sub.route.split("/").includes(it.permission.slug) &&
                          !it.mobile_only
                      )
                    );
                    console.log('Sub-route permission check (expanded):', item.title, hasSubPermission ? 'allowed' : 'denied');
                    return hasSubPermission;
                  }
                  console.log('Filtered out (expanded):', item.title, '- no route or subroutes');
                  return false;
                })
                .map((item, index) =>
                  item.subRoutes ? (
                    <ListItem
                      key={index}
                      disablePadding
                      sx={{ display: "block" }}
                    >
                      {(item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") || 
                       item.subRoutes.filter((sub) =>
                         adminAuth.adminDetail?.role?.role_permissions?.find(
                           (it) =>
                             sub.route.split("/").includes(it.permission.slug) &&
                             !it.mobile_only
                         )
                       )?.length ? (
                        <ListItemButton
                          onClick={() => handleClick(item.title)}
                          sx={{
                            "&.Mui-selected": {
                              backgroundColor: "transparent !important",
                            },
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: "36px",
                              width: "36px",
                              height: "36px",
                              borderRadius: "50%",
                              border: "none",
                              backgroundColor: "rgba(0, 0, 0, 0.08)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "8px",
                              marginLeft: "-3.25px",
                              padding: "0px",
                              "& .MuiSvgIcon-root": {
                                fontSize: "20px",
                              },
                              "& img": {
                                width: "16px",
                                marginLeft: "0px",
                              },
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                          <ListItemText
                            classes={{ primary: classes.sideBarListText }}
                            primary={item.title}
                          />
                          {open.includes(item.title) ? (
                            <ExpandLess
                              sx={{ color: "#BDBDBD", fontSize: "22px" }}
                            />
                          ) : (
                            <ExpandMore
                              sx={{ color: "#BDBDBD", fontSize: "22px" }}
                            />
                          )}
                        </ListItemButton>
                      ) : null}

                      <Collapse
                        className={`${classes.navCollapseItems} ${muiClasses.collapsedIcon}`}
                        in={open.includes(item.title)}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>
                          {item.subRoutes.map((item1, index1) =>
                            (item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") ||
                            adminAuth.adminDetail?.role?.role_permissions?.find(
                              (it) =>
                                item1.route
                                  .split("/")
                                  .includes(it.permission.slug) &&
                                !it.mobile_only
                            ) ? (
                              <ListItemButton
                                key={index1}
                                onClick={() =>
                                  handleChangeRoute(item1.route, item.title)
                                }
                                sx={{
                                  pl: 7.15,
                                  "&.Mui-selected": {
                                    backgroundColor: "transparent !important",
                                  },
                                  "&:hover": {
                                    backgroundColor:
                                      "rgba(0, 0, 0, 0.04) !important",
                                  },
                                }}
                              >
                                <ListItemText
                                  classes={{ primary: classes.sideBarListText }}
                                  primary={item1.title}
                                />
                              </ListItemButton>
                            ) : null
                          )}
                        </List>
                      </Collapse>
                    </ListItem>
                  ) : (item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") ||
                    adminAuth.adminDetail?.role?.role_permissions?.find(
                      (it) =>
                        item.route.split("/").includes(it.permission.slug) &&
                        !it.mobile_only
                    ) ? (
                    <ListItemButton
                      onClick={() => handleChangeRoute(item.route, item.title)}
                      key={index}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: props.pcOpen ? "36px" : "40px",
                          width: "36px",
                          height: "36px",
                          borderRadius: "50%",
                          border: "none",
                          backgroundColor: "rgba(0, 0, 0, 0.08)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "8px",
                          marginLeft: props.pcOpen ? "-3.25px" : "0px",
                          padding: "0px",
                          "& .MuiSvgIcon-root": {
                            fontSize: "20px",
                          },
                          "& img[alt='listingIcon']": {
                            width: props.pcOpen ? "16px" : "18px",
                            marginLeft: props.pcOpen ? "1.5px" : "3px",
                            marginTop: "1px !important",
                            height: "auto",
                            display: "flex",
                            alignSelf: "center",
                            justifySelf: "center",
                          },
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        classes={{ primary: classes.sideBarListText }}
                        primary={item.title}
                      />
                    </ListItemButton>
                  ) : null
                )}
            </List>
          ) : (
            <List sx={{ paddingTop: "0px" }}>
              {navBarMenu
                .filter((item) => {
                  // Debug logging
                  console.log('Filtering item (collapsed):', item.title, {
                    hasRoute: !!item.route,
                    hasSubRoutes: !!item.subRoutes,
                    isAdminOnly: item.adminOnly,
                    userRole: adminAuth.adminDetail?.role?.name,
                    isAdmin: adminAuth.adminDetail?.role?.name === "Admin"
                  });
                  
                  // Check if item is admin-only and user is not admin
                  if (item.adminOnly && adminAuth.adminDetail?.role?.name !== "Admin") {
                    console.log('Filtered out (collapsed):', item.title, '- admin only, user not admin');
                    return false;
                  }
                  
                  if (item.route) {
                    // For direct routes
                    // Special case for admin-only items
                    if (item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") {
                      console.log('Allowed (collapsed):', item.title, '- admin only, user is admin');
                      return true;
                    }
                    const hasPermission = adminAuth.adminDetail?.role?.role_permissions?.find(
                      (it) =>
                        item.route.split("/").includes(it.permission.slug) &&
                        !it.mobile_only
                    );
                    console.log('Route permission check (collapsed):', item.title, hasPermission ? 'allowed' : 'denied');
                    return hasPermission;
                  } else if (item.subRoutes) {
                    // For items with subroutes
                    // If it's admin-only and user is admin, allow it
                    if (item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") {
                      console.log('Allowed (collapsed):', item.title, '- admin only with subroutes, user is admin');
                      return true;
                    }
                    // Otherwise check sub-route permissions
                    const hasSubPermission = item.subRoutes.some((sub) =>
                      adminAuth.adminDetail?.role?.role_permissions?.find(
                        (it) =>
                          sub.route.split("/").includes(it.permission.slug) &&
                          !it.mobile_only
                      )
                    );
                    console.log('Sub-route permission check (collapsed):', item.title, hasSubPermission ? 'allowed' : 'denied');
                    return hasSubPermission;
                  }
                  console.log('Filtered out (collapsed):', item.title, '- no route or subroutes');
                  return false;
                })
                .map((item, index) =>
                  item.subRoutes ? (
                    <OutsideClickHandler
                      onOutsideClick={() => {
                        setShortMenu((prev) => ({
                          ...prev,
                          [item.title]: false,
                        }));
                      }}
                    >
                      <ListItem
                        key={index}
                        disablePadding
                        sx={{ display: "block" }}
                        className={muiClasses.collapsedIcon}
                      >
                        {(item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") || 
                         item.subRoutes.filter((sub) =>
                           adminAuth.adminDetail?.role?.role_permissions?.find(
                             (it) =>
                               sub.route
                                 .split("/")
                                 .includes(it.permission.slug) && !it.mobile_only
                           )
                         )?.length ? (
                          <ListItemButton
                            onClick={() => handleClick(item.title)}
                            sx={{
                              "&.Mui-selected": {
                                backgroundColor: "transparent !important",
                              },
                              "&:hover": {
                                backgroundColor:
                                  "rgba(0, 0, 0, 0.04) !important",
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: "36px",
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                border: "none",
                                backgroundColor: "rgba(0, 0, 0, 0.08)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: "8px",
                                marginLeft: "-3.25px",
                                padding: "0px",
                                "& .MuiSvgIcon-root": {
                                  fontSize: "20px",
                                },
                                "& img": {
                                  width: "16px",
                                  marginLeft: "0px",
                                },
                              }}
                            >
                              {item.icon}
                            </ListItemIcon>
                          </ListItemButton>
                        ) : null}
                        {open.includes(item.title) && shortMenu[item.title] && (
                          <div
                            className={muiClasses.navCollapseItems}
                            style={{ zIndex: `${999 + index}` }}
                          >
                            <List component="div" disablePadding>
                              {item.subRoutes.map((item1, index1) =>
                                (item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") ||
                                adminAuth.adminDetail?.role?.role_permissions?.find(
                                  (it) =>
                                    item1.route
                                      .split("/")
                                      .includes(it.permission.slug) &&
                                    !it.mobile_only
                                ) ? (
                                  <ListItemButton
                                    key={index1}
                                    onClick={() =>
                                      handleChangeRoute(item1.route, item.title)
                                    }
                                    sx={{
                                      pl: 2.5,
                                      "&.Mui-selected": {
                                        backgroundColor:
                                          "transparent !important",
                                      },
                                      "&:hover": {
                                        backgroundColor:
                                          "rgba(0, 0, 0, 0.04) !important",
                                      },
                                    }}
                                  >
                                    <ListItemText
                                      classes={{
                                        primary: classes.sideBarListText,
                                      }}
                                      primary={item1.title}
                                    />
                                  </ListItemButton>
                                ) : null
                              )}
                            </List>
                          </div>
                        )}
                      </ListItem>
                    </OutsideClickHandler>
                  ) : (
                    <ListItem
                      key={index}
                      disablePadding
                      className={muiClasses.collapsedIcon}
                    >
                      <ListItemButton
                        onClick={() =>
                          handleChangeRoute(item.route, item.title)
                        }
                      >
                        {(item.adminOnly && adminAuth.adminDetail?.role?.name === "Admin") ||
                        adminAuth.adminDetail?.role?.role_permissions?.find(
                          (it) =>
                            item.route
                              .split("/")
                              .includes(it.permission.slug) && !it.mobile_only
                        ) ? (
                          <ListItemIcon
                            sx={{
                              minWidth: props.pcOpen ? "36px" : "40px",
                              width: "36px",
                              height: "36px",
                              borderRadius: "50%",
                              border: "none",
                              backgroundColor: "rgba(0, 0, 0, 0.08)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "8px",
                              marginLeft: props.pcOpen ? "-3.25px" : "0px",
                              padding: "0px",
                              "& .MuiSvgIcon-root": {
                                fontSize: "20px",
                              },
                              "& img[alt='listingIcon']": {
                                width: props.pcOpen ? "16px" : "18px",
                                marginLeft: props.pcOpen ? "1.5px" : "3px",
                                marginTop: "1px !important",
                                height: "auto",
                                display: "flex",
                                alignSelf: "center",
                                justifySelf: "center",
                              },
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                        ) : null}
                      </ListItemButton>
                    </ListItem>
                  )
                )}
            </List>
          )}
        </div>
      )}
    </React.Fragment>
  );
}
export default withStyles(styleSheet, { name: "SideNavBarStyle" })(SideNavBar);
